import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { ChromeTab, Tab } from "@/types"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function chromeTabToTab(chromeTab: ChromeTab): Tab {
  return {
    tab_id: chromeTab.id,
    collection_id: "",
    user_id: "",
    title: chromeTab.title,
    url: chromeTab.url,
    favicon_url: chromeTab.favIconUrl,
    sequence: 0,
    status: "ACTIVE",
    created_at: "",
    updated_at: "",
  }
}
